import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link, Route, Redirect, Switch, withRouter} from 'react-router-dom';
import {AppBar, Toolbar, IconButton, Typography, Hidden, Drawer, Button} from '@material-ui/core';
import {Menu as MenuIcon, PersonOutline as AccountBox} from '@material-ui/icons';
import {isEmpty} from 'lodash/lang';
import FlashMessage from 'components/FlashMessage';
import Login from './Account/Login';
import Routes from './routes';
import {fetchCurrentAccount, logout} from 'actions/account';
import {formatErrors} from 'actions/errors';
import withoutAuth from 'utils/without-auth';
import withAuth from 'utils/with-auth';
import DrawerMenu from './DrawerMenu';
import QuizTake from '../components/Quiz/QuizTake';
import QuizUserResult from './Quiz/QuizUserResult';
import QuizStartConfirm from './Quiz/QuizStartConfirm';
import ChangePasswordContainer from './Account/ChangePasswordContainer';
import ResetPassword from './Account/ResetPassword';
import Spinner from './common/Spinner';
import {LoadingContextProvider} from '../contexts/LoadingContext';


class App extends React.Component {
    static contextTypes = {
        router: PropTypes.object.isRequired,
    };
    static propTypes = {
        user: PropTypes.object.isRequired,
        formatErrors: PropTypes.func.isRequired,
        fetchCurrentAccount: PropTypes.func.isRequired,
        logout: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isAuthenticated: null,
            mobileDrawerOpen: false,
        };
        this.handleLogout = this.handleLogout.bind(this);
        this.renderWithoutAuth = this.renderWithoutAuth.bind(this);
        this.renderWithAuth = this.renderWithAuth.bind(this);
        this.toggleMobileDrawer = this.toggleMobileDrawer.bind(this);
    }

    componentDidMount() {
        if (!localStorage.getItem('cwbJwt')) {
            this.setState({isAuthenticated: false});
        } else {
            this.props.fetchCurrentAccount()
                .then(() => this.setState({isAuthenticated: true}))
                .catch(() => this.setState({isAuthenticated: false}));
        }
    }

    handleLogout() {
        const {logout, formatErrors} = this.props;
        logout()
            .then(() => {
                this.context.router.history.push('/');
            })
            .catch(err => formatErrors(err));
    }

    renderWithoutAuth() {
        return (
            <>
                <Switch>
                    <Route exact path="/quizzes/:quizId(\w+)/confirm" component={withoutAuth(QuizStartConfirm)} />
                    <Route exact path="/quizzes/:quizId(\w+)/take" component={withoutAuth(QuizTake)}/>
                    <Route exact path="/quizzes/:quizUserId(\w+)/answers" component={withoutAuth(QuizUserResult)}/>
                    <Route exact path="/reset" component={withoutAuth(ResetPassword)}/>
                    <Route path="/login/reset-password" component={withoutAuth(ChangePasswordContainer)}/>
                    <Route path="/account/login" component={withoutAuth(Login)}/>
                    <Redirect to="/account/login"/>
                </Switch>
            </>
        );
    }

    renderWithAuth() {
        const {mobileDrawerOpen} = this.state;
        const {user} = this.props;
        return (
            <>
                <AppBar position="fixed" className="app-bar">
                    <Toolbar>
                        <Hidden mdUp>
                            <IconButton color="inherit" onClick={this.toggleMobileDrawer}>
                                <MenuIcon/>
                            </IconButton>
                        </Hidden>
                        <Typography variant="h6">
                            <Link to="/">Quizscape</Link>
                        </Typography>
                        <div className="logout-container">
                            <AccountBox className="logout-icon"/>
                            <div className="logout">
                                <p>{unescape(user.name)}</p>
                                <Button color="inherit" onClick={this.handleLogout}>Logout</Button>
                            </div>
                        </div>
                    </Toolbar>
                </AppBar>
                <div className="app-body">
                    <Hidden mdUp>
                        <Drawer
                            className="drawer-menu"
                            variant="temporary"
                            anchor="left"
                            open={mobileDrawerOpen}
                            onClose={this.toggleMobileDrawer}
                            ModalProps={{keepMounted: true}}
                        >
                            <DrawerMenu/>
                        </Drawer>
                    </Hidden>
                    <Hidden smDown implementation="css">
                        <Drawer className="drawer-menu sidebar" variant="permanent" open>
                            <DrawerMenu/>
                        </Drawer>
                    </Hidden>
                    <main>
                        {React.createElement(withAuth(Routes))}
                    </main>
                </div>
            </>
        );
    }

    toggleMobileDrawer() {
        this.setState(prevState => ({
            mobileDrawerOpen: !prevState.mobileDrawerOpen,
        }));
    }

    render() {
        const {isAuthenticated} = this.state;
        if (isAuthenticated === null) {
            return null;
        }
        const {user} = this.props;
        return (
            <>
                <LoadingContextProvider>
                    <FlashMessage/>
                    <Spinner/>
                    {!isEmpty(user) ? this.renderWithAuth() : this.renderWithoutAuth()}
                </LoadingContextProvider>
            </>
        );
    }
}

export default withRouter(
    connect(
        ({account: {user}}) => ({
            user,
        }),
        {
            formatErrors,
            fetchCurrentAccount,
            logout,
        },
    )(App)
);
